
















import Vue from 'vue';
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';

export default Vue.extend({
    created() {
        window.FRSToolV3.getConfig({ page: 'index', type: 'importantNotic' }).then((res: any) => {
            this.datalist = res.result;
        });
    },
    data() {
        return {
            datalist: [],
            marqueeSwiperOption: {
                direction: 'vertical',
                loop: true,
                autoHeight: true,
                height: 120,
                slidesPerView: 1,
                spaceBetween: 30,
                mousewheel: true,
                autoplay: {
                    delay: 5000
                }
            }
        };
    },
    components: {
        swiper,
        swiperSlide
    },
    methods: {
        GAcode(el: string) {
            if (typeof window.ActionAnalysisV2 !== 'undefined' && typeof el !== 'undefined') {
                window.ActionAnalysisV2.actClk(el);
            }
        }
    }
});
